import { render, staticRenderFns } from "./NavigationDrawerCustom.vue?vue&type=template&id=96d404fa&"
import script from "./NavigationDrawerCustom.vue?vue&type=script&lang=js&"
export * from "./NavigationDrawerCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports